module.exports = __webpack_public_path__ + "img/sachsen-anhalt.ae4c7e6.webp";